function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from './fpc.scss';
import template from './fpc.html';

export var FpcComponent = {
  template: template,
  styles: styles,
  bindings: {
    fpcData: '<' },

  controller: /*#__PURE__*/function () {
    function FpcComponentController() {
      "ngInject";_classCallCheck(this, FpcComponentController);
      console.log(this);
    }_createClass(FpcComponentController, [{ key: "$onInit", value: function $onInit()

      {} }, { key: "$onChanges", value: function $onChanges()

      {
        if (this.fpcData) {
          this.fats = parseFloat(this.fpcData.fats).toFixed(0);
          this.pro = parseFloat(this.fpcData.proteins).toFixed(0);
          this.carbs = parseFloat(this.fpcData.carbohydrates).toFixed(0);
          if (this.fpcData.logged_meal_items) {
            this.loggedFats = parseFloat(this.fpcData.logged_meal_items.reduce(function (a, b) {return a + b.fats;}, 0)).toFixed(0);
            this.loggedPro = parseFloat(this.fpcData.logged_meal_items.reduce(function (a, b) {return a + b.proteins;}, 0)).toFixed(0);
            this.loggedCarbs = parseFloat(this.fpcData.logged_meal_items.reduce(function (a, b) {return a + b.carbohydrates;}, 0)).toFixed(0);
          } else {
            this.loggedFats = this.fats;
            this.loggedPro = this.pro;
            this.loggedCarbs = this.carbs;
          }
          this.fatsProgress = Math.ceil(this.loggedFats / this.fats * 100);
          this.proProgress = Math.ceil(this.loggedPro / this.pro * 100);
          this.carbsProgress = Math.ceil(this.loggedCarbs / this.carbs * 100);
          this.overFatsProgress = this.fatsProgress - 100;
          this.overProProgress = this.proProgress - 100;
          this.overCarbsProgress = this.carbsProgress - 100;
        }
      } }]);return FpcComponentController;}() };